
export type AspectRatio = '1:1' | '4:3' | '3:4' | '16:9' | '9:16' | '3:2' | '2:3';

export type FrameStyle = 'none' | 'white' | 'black' | 'custom';

export interface Point {
  x: number; // 0 to 100 (percentage)
  y: number; // 0 to 100 (percentage)
}

export interface FrameSides {
  top: boolean;
  bottom: boolean;
  left: boolean;
  right: boolean;
}

export const ASPECT_RATIOS: Record<AspectRatio, number> = {
  '1:1': 1,
  '4:3': 4/3,
  '3:4': 3/4,
  '16:9': 16/9,
  '9:16': 9/16,
  '3:2': 3/2,
  '2:3': 2/3,
};

// 日常祝福詞
export const PRESET_GREETINGS = [
  '早安', '午安', '晚安', 
  '平安喜樂', '吉祥如意', '知足常樂', 
  '認同請分享', '健康平安', '天天開心',
  '心想事成', '福氣滿滿', '祝你愉快',
  '順心如意', '身體健康', '能量滿滿',
  '萬事大吉', '好運連連'
];

// 新年祝福詞
export const NEW_YEAR_GREETINGS = [
  '新年快樂', '恭喜發財', '萬事如意',
  '年年有餘', '歲歲平安', '大吉大利',
  '財源廣進', '步步高升', '闔家安康',
  '五福臨門', '六六大順', '十全十美',
  '福星高照', '鴻運當頭', '龍年行大運',
  '心想事成', '身體健康'
];

// 馬年祝福詞
export const HORSE_YEAR_GREETINGS = [
  '馬到成功', '一馬當先', '龍馬精神',
  '馬年行大運', '馬上發財', '馬上有錢',
  '馬年吉祥', '馬年如意', '馬年平安',
  '萬馬奔騰', '駿馬奔騰', '馬年大吉',
  '馬年快樂', '馬年幸福', '馬年健康',
  '馬年順心', '馬年如意'
];

export const COLORS = [
  { name: '亮金黃', value: '#FFD700' },
  { name: '喜慶紅', value: '#FF0000' },
  { name: '純潔白', value: '#FFFFFF' },
  { name: '沉穩黑', value: '#000000' },
  { name: '活力橘', value: '#FF8C00' },
  { name: '翠玉綠', value: '#008000' },
  { name: '天空藍', value: '#00BFFF' },
  { name: '魅力紫', value: '#8600FF' },
  { name: '彩虹黑邊', value: 'rainbow-black' },
  { name: '彩虹白邊', value: 'rainbow-white' },
];

export const FONTS = [
  { name: '黑體', value: '"Noto Sans TC", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "PingFang SC", sans-serif' },
  { name: '明體', value: '"Noto Serif TC", "Times New Roman", "Songti SC", serif' },
  { name: '圓體', value: '"Huninn", "M PLUS Rounded 1c", "Noto Sans TC", -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif' },
  { name: '手寫體', value: '"Chenyu Luoyan Thin", "Noto Serif TC", "PingFang SC", "Microsoft YaHei", serif' },
];
